/**
 * Should this page be an "Internal" or super admin / dev page instead?
 */
import { lazy, Suspense } from 'react';

import { NavLink, Switch } from 'react-router-dom';

import { RoleName } from '@m/types/api/iam/Iam';
import AuthenticatedRoute from 'apps/admin/components/AuthenticatedRoute';
import { navLinkStyle } from 'apps/admin/components/BreadCrumbs/active';

const FeatureFlagsPage = lazy(() => import('apps/admin/containers/FeatureFlagsPage'));
const FeatureFlagsPageV2 = lazy(
  () => import('apps/admin/containers/FeatureFlagsPage/FeatureFlagsPageV2'),
);

export const featureFlagsRoutesConfig = [
  {
    exact: true,
    path: '/feature-flags-legacy',
    breadcrumb: () => (
      <NavLink to="/feature-flags-legacy" activeStyle={navLinkStyle}>
        Feature Flags
      </NavLink>
    ),
    roles: [RoleName.OPERATIONAL_ADMIN],
    component: AuthenticatedRoute,
    children: (
      <Suspense fallback={null}>
        <FeatureFlagsPage />
      </Suspense>
    ),
  },
  {
    exact: true,
    path: '/feature-flags',
    breadcrumb: () => (
      <NavLink to="/feature-flags" activeStyle={navLinkStyle}>
        Feature Flags
      </NavLink>
    ),
    roles: [RoleName.OPERATIONAL_ADMIN],
    component: AuthenticatedRoute,
    children: (
      <Suspense fallback={null}>
        <FeatureFlagsPageV2 />
      </Suspense>
    ),
  },
];

export default function FeatureFlagRoutes() {
  return (
    <Switch>
      {featureFlagsRoutesConfig.map(
        ({ component: Component, breadcrumb, ...props }) =>
          Component && <Component key={props.path} {...props} />,
      )}
    </Switch>
  );
}
